









































import isEmpty from "lodash/isEmpty";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "EventAddCarpPopupComponent",
  components: {},
})
export default class EventAddCarpPopupComponent extends Vue {
  public isShow = false;

  public config = {
    language: "jp",
  };
  public errors = {};

  @Watch("isShow")
  public reset() {
    if (this.isShow === true) {
      this.config = {
        language: "jp",
      };
    }
  }

  public async checkForm() {
    this.errors = {};

    if (this.config.language === "") {
      this.errors = {
        ...this.errors,
        ...{
          "config.language": ["必須入力"],
        },
      };
    }
  }

  public submit() {
    this.isShow = false;
    this.checkForm().then(() => {
      if (isEmpty(this.errors)) {
        this.$emit("generateCarp", this.config);
      }
    });
  }

  public show() {
    this.isShow = true;
  }
}
